import React from 'react';
import styles from './ServiceIcon.module.css';

const DesignIcon = () => (
  <div className={styles.iconWrapper}>
    <span className={`${styles.shape} ${styles.shapeSquare}`}>■</span>
    <span className={`${styles.shape} ${styles.shapeTriangle}`}>▲</span>
    <span className={`${styles.shape} ${styles.shapeCircle}`}>●</span>
  </div>
);

const WebIcon = () => (
  <div className={styles.webWrapper}>
    <svg
      viewBox="0 0 60 60"
      width="55"
      height="55"
      fill="none"
      stroke="#333"
      strokeLinecap="round"
      className={styles.globeSvg}
    >
      {/* Globe structure */}
      <circle cx="30" cy="30" r="24" strokeWidth="1.5" />
      <ellipse cx="30" cy="21" rx="22.2" ry="4.5" strokeWidth="0.8" />
      <ellipse cx="30" cy="39" rx="22.2" ry="4.5" strokeWidth="0.8" />
      <line x1="6" y1="30" x2="54" y2="30" strokeWidth="0.8" />
      <ellipse cx="30" cy="30" rx="11" ry="24" strokeWidth="0.8" />

      {/* Network connecting lines — draw in on hover, radiating N→S and E/W inward */}
      <line className={`${styles.netLine} ${styles.nl1}`}  x1="30" y1="6"  x2="19" y2="25" strokeWidth="0.9" /> {/* N→UL */}
      <line className={`${styles.netLine} ${styles.nl2}`}  x1="30" y1="6"  x2="41" y2="25" strokeWidth="0.9" /> {/* N→UR */}
      <line className={`${styles.netLine} ${styles.nl3}`}  x1="19" y1="25" x2="41" y2="25" strokeWidth="0.9" /> {/* UL→UR */}
      <line className={`${styles.netLine} ${styles.nl4}`}  x1="6"  y1="30" x2="19" y2="25" strokeWidth="0.9" /> {/* W→UL */}
      <line className={`${styles.netLine} ${styles.nl5}`}  x1="6"  y1="30" x2="19" y2="35" strokeWidth="0.9" /> {/* W→LL */}
      <line className={`${styles.netLine} ${styles.nl6}`}  x1="54" y1="30" x2="41" y2="25" strokeWidth="0.9" /> {/* E→UR */}
      <line className={`${styles.netLine} ${styles.nl7}`}  x1="54" y1="30" x2="41" y2="35" strokeWidth="0.9" /> {/* E→LR */}
      <line className={`${styles.netLine} ${styles.nl8}`}  x1="19" y1="35" x2="41" y2="35" strokeWidth="0.9" /> {/* LL→LR */}
      <line className={`${styles.netLine} ${styles.nl9}`}  x1="19" y1="35" x2="30" y2="54" strokeWidth="0.9" /> {/* LL→S */}
      <line className={`${styles.netLine} ${styles.nl10}`} x1="41" y1="35" x2="30" y2="54" strokeWidth="0.9" /> {/* LR→S */}

      {/* 8 network nodes */}
      <circle className={styles.netNode} cx="30" cy="6"  r="1.8" fill="#333" stroke="none" /> {/* N  */}
      <circle className={styles.netNode} cx="30" cy="54" r="1.8" fill="#333" stroke="none" /> {/* S  */}
      <circle className={styles.netNode} cx="6"  cy="30" r="1.8" fill="#333" stroke="none" /> {/* W  */}
      <circle className={styles.netNode} cx="54" cy="30" r="1.8" fill="#333" stroke="none" /> {/* E  */}
      <circle className={styles.netNode} cx="19" cy="25" r="1.8" fill="#333" stroke="none" /> {/* UL */}
      <circle className={styles.netNode} cx="41" cy="25" r="1.8" fill="#333" stroke="none" /> {/* UR */}
      <circle className={styles.netNode} cx="19" cy="35" r="1.8" fill="#333" stroke="none" /> {/* LL */}
      <circle className={styles.netNode} cx="41" cy="35" r="1.8" fill="#333" stroke="none" /> {/* LR */}
    </svg>
  </div>
);

const MobileIcon = () => (
  <div className={styles.mobileWrapper}>
    <span className={`${styles.square} ${styles.r1c1}`} />
    <span className={`${styles.square} ${styles.r1c2}`} />
    <span className={`${styles.square} ${styles.r2c1}`} />
    <span className={`${styles.square} ${styles.r2c2}`} />
    <span className={`${styles.square} ${styles.r3c1}`} />
    <span className={`${styles.square} ${styles.r3c2}`} />
    <span className={`${styles.square} ${styles.r4c1}`} />
    <span className={`${styles.square} ${styles.r4c2}`} />
  </div>
);

const AutomationIcon = () => (
  <div className={styles.automationWrapper}>
    {/* Outer div handles translation, inner span handles rotation */}
    <div className={styles.gear1Wrap}>
      <span className={styles.gear1Spin}>⚙</span>
    </div>
    <div className={styles.gear2Wrap}>
      <span className={styles.gear2Spin}>⚙</span>
    </div>

    {/* Directional arrows — fade in between gears as they separate */}
    <div className={styles.dataArrows}>
      <svg width="20" height="22" viewBox="0 0 20 22" fill="none" stroke="#333" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        {/* Right arrow (top) — long shaft, small head */}
        <line x1="0" y1="6" x2="17" y2="6" />
        <polyline points="14,3 17,6 14,9" />
        {/* Left arrow (bottom) — long shaft, small head */}
        <line x1="20" y1="16" x2="3" y2="16" />
        <polyline points="6,13 3,16 6,19" />
      </svg>
    </div>
  </div>
);

const ServiceIcon = ({ type }) => {
  if (type === 'design') return <DesignIcon />;
  if (type === 'web') return <WebIcon />;
  if (type === 'mobile') return <MobileIcon />;
  if (type === 'automation') return <AutomationIcon />;
  return null;
};

export default ServiceIcon;
